import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import { useMediaQuery } from '@mui/material';

const Hero = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      width={'100%'}
      maxHeight={'450px'}
      height={{ xs: 'auto', sm: '450px' }}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        padding: { xs: '64px 16px', md: '64px' },
        background: theme.palette.lightGrey[200],
      }}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        maxWidth={'768px'}
        width={'100%'}
        alignItems={'center'}
        marginBottom={{ xs: '32px', sm: '32px', md: '40px' }}
      >
        <Typography
          variant="h4"
          color={theme.palette.darkGrey[700]}
          sx={{
            fontWeight: 700,
            width: '100%',
            letterSpacing: '-0.72px',
            marginBottom: { xs: '16px', sm: '8px' },
            textAlign: 'center',
          }}
        >
          {t('tournamentsTitle')}
        </Typography>
        <Typography
          variant={isMd ? 'body2' : 'body3'}
          color={theme.palette.darkGrey[600]}
          sx={{
            fontWeight: 400,
            maxWidth: '501px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {t('tournamentsSubtitle')}
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} width={'100%'}>
        <Button
          buttontype={'orange'}
          width={{ xs: '100%', sm: 'auto' }}
          onClick={() =>
            navigate('/turnyras', {
              state: { to: '/turnyras' },
            })
          }
        >
          {t('viewTournaments')}
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;
